import React from "react"
import clsx from "clsx"

import classes from "./SsItem.module.scss"

const SsItem = props => {
  const {
    label,
    onClick,
    goToTab,
    currentTab
  } = props

  return (
    <div
      onClick={onClick}
      className={clsx(
        classes["tab"],
        !!currentTab &&
        currentTab === goToTab &&
        classes["active"]
      )}
    >
      {label}
    </div>

  )
}

export default SsItem